module.exports = __webpack_public_path__ + "img/price-3.0c4e0939.png";